module.exports = __webpack_public_path__ + "static/img/2.ffb2c5e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/8/eng/2.png
// module id = SdT1
// module chunks = 0